import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AppContext } from '../AppContext';

interface FormValues {
  type: string;
}

const Intro: React.FC = () => {
  const navigate = useNavigate();
  const context = useContext(AppContext);

  // Verifica se o contexto está definido
  if (!context) {
    throw new Error('Step1 must be used within an AppProvider');
  }

  const { appData, updateAppData } = context;

  return (
    <div className="content">
      <div className="mx-auto max-w-2xl lg:text-center">
        <p className="color-primary mt-2 text-4xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-5xl lg:text-balance">Bem-vindo ao Personalizador de App</p>
        <p className="mt-6 font-semibold tracking-tight text-pretty text-gray-900 sm:text-2xl lg:text-balance">Monte o visual do seu app de forma simples e rápida</p>
        <p className="mt-2 text-lg/8 text-gray-600">Este é um processo interativo para definir a aparência e os recursos do seu aplicativo antes do desenvolvimento.</p>
        <div className='border-2  border-solid mt-6 p-6 rounded-xl'>
          <p className="font-semibold sm:text-2xl">Como funciona?</p>
          <ul className="mt-4" role="list">
            <li>Escolha o tipo e os recursos do seu app.</li>
            <li>Defina o título e a descrição.</li>
            <li>Envie a logomarca e personalize as cores.</li>
            <li>Monte a tela inicial e configure a navegação.</li>
            <li>Finalize e envie os dados para a configuração do app.</li>
          </ul>
        </div>
      </div>
      <div>
        <p className="mt-6 font-semibold">Importante:</p>
        <p className="mt-2">📌 Não atualize nem feche o navegador antes de concluir o processo, pois isso pode resultar na perda das informações inseridas.</p>
        <p className="mt-2">📌 Este processo é apenas para a criação inicial do app. Após o desenvolvimento, alterações na aparência como logomarca e cores exigirão novas atualizações do app.</p>
        <p className="mt-2">📌 O resultado gerado é apenas uma estimativa visual de como seu app poderá ficar. Pequenas diferenças podem ocorrer na versão final.</p>
      </div>
      <div className="flex justify-end mt-4">
        <Link
            to={`/${appData.id}/tipo`}
            className="bg-primary text-white px-6 py-3 text-xl rounded-md flex items-center space-x-2"
          >
          <span>Iniciar</span>
          <i className="fas fa-arrow-right"></i>
        </Link>
      </div>
    </div>
  );
};

export default Intro;